import React, { useEffect, useRef, useState } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import apis from '../../api';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import '../../DataTableDemo.css';
import { Chart } from 'primereact/chart';
import { useHistory } from "react-router-dom";
import { Dialog } from 'primereact/dialog';

export default function Home() {

    const [payroll_payment, setPayroll_payment] = useState([]);
    const headers = { authorization: localStorage.getItem('token') }
    const [namePayrollBudget, setNamePayrollBudget] = useState('');
    const [datasetsPayrollBudget, setDatasetsPayrollBudget] = useState([]);
    const [labelPayrollBudget, setLabelPayrollBudget] = useState([]);
    const [nameEmployeeBudget, setNameEmployeeBudget] = useState('');
    const [datasetsEmployeeBudget, setDatasetsEmployeeBudget] = useState([]);
    const [labelEmployeeBudget, setLabelEmployeeBudget] = useState([]);
    const [pending_invoices, setPending_invoices] = useState([]);
    const [dataPassiveLabor, setDataPassiveLabor] = useState([]);
    const [labelPassiveLabor, setLabelPassiveLabor] = useState([]);
    const [totalPassiveLabor, setTotalPassiveLabor] = useState('');
    const [labelPayAbsenceType, setLabelPayAbsenceType] = useState([]);
    const [labelPayAbsenceDays, setLabelPayAbsenceDays] = useState([]);
    const [dataPayAbsenceType, setDataPayAbsenceType] = useState([]);
    const [dataPayAbsenceDays, setDataPayAbsenceDays] = useState([]);
    const [namePayAbsenceType, setNamePayAbsenceType] = useState('');
    const [namePayAbsenceDays, setNamePayAbsenceDays] = useState('');

    const [isOpen, setIsOpen] = useState(false)

    const showModal = () => {
        setIsOpen(true)
    }

    const hideModal = () => {
        setIsOpen(false)
        localStorage.setItem('pay_modal', 'S')
    }

    let history = useHistory();
    const toast = useRef(null);

    useEffect(() => {
        if (localStorage.getItem('enabled') === "N") {
            history.push("/Verification")
            // window.location.href = "./Verification"
        }
    }, [])

    useEffect(() => {
        const getBusiness = async () => {
            await apis.getBusiness(localStorage.getItem('token'), headers).then(res => {
                localStorage.setItem('client', res.data.COMPANY[0]["CLIENT"]);
                localStorage.setItem('logo', res.data.COMPANY[0]["IMAGES"])
            })
        }
        getBusiness()
    }, [])

    useEffect(() => {
        apis.getPayment(localStorage.getItem('entity'), localStorage.getItem('client'), headers).then(res => {
            let data = res.data['PAYROLL_PAYMENT']
            setPayroll_payment(Intl.NumberFormat("es-CO", { style: "currency", currency: "COP", }).format(data))
            // console.log(data)
        }).catch(res => {
            console.log(res)
        })
    }, []);

    useEffect(() => {
        apis.GetPending_invoices(localStorage.getItem('entity'), localStorage.getItem('client'), headers).then(res => {
            let data = res.data;
            setPending_invoices(data.DATA);
            if (data.DATA !== 'Sin pendientes.') {
                showModal()
            }
        }).catch(res => {
            console.log(res)
        });
    }, [payroll_payment]);

    useEffect(() => {
        apis.getGetPayroll_budget(localStorage.getItem('entity'), localStorage.getItem('client'), headers).then(res => {
            let data = res.data;
            setLabelPayrollBudget(data.label)
            setDatasetsPayrollBudget(data.datasets)
            setNamePayrollBudget(data.name)
            // console.log(data)
        }).catch(res => {
            console.log(res)
        });
    }, [payroll_payment]);

    useEffect(() => {
        apis.getGetEmployee_budget(localStorage.getItem('entity'), localStorage.getItem('client'), headers).then(res => {
            let data = res.data;
            setLabelEmployeeBudget(data.label)
            setDatasetsEmployeeBudget(data.datasets)
            setNameEmployeeBudget(data.name)
            // console.log(data)
        }).catch(res => {
            console.log(res)
        });
    }, [payroll_payment]);

    useEffect(() => {
        apis.getPassiveLabor(localStorage.getItem('entity'), localStorage.getItem('client'), headers).then(res => {
            let data = res.data
            setLabelPassiveLabor(data.label)
            setDataPassiveLabor(data.datasets)
            // console.log(data)
        }).catch(res => {
            console.log(res)
        })
    }, [])

    useEffect(() => {
        apis.getTotalPassiveLabor(localStorage.getItem('entity'), localStorage.getItem('client'), headers).then(res => {
            let data = res.data.PAYROLL_CSO
            setTotalPassiveLabor(Intl.NumberFormat("es-CO", { style: "currency", currency: "COP", }).format(data))
        }).catch(res => {
            console.log(res)
        })
    }, [])

    useEffect(() => {
        apis.getPayAbsenceType(localStorage.getItem('entity'), localStorage.getItem('client'), headers).then(res => {
            let data = res.data
            setDataPayAbsenceType(data.datasets)
            setLabelPayAbsenceType(data.label)
            setNamePayAbsenceType(data.name)
        }).catch(res => {
            console.log(res)
        })
    }, [])

    useEffect(() => {
        apis.getPayAbsenceDays(localStorage.getItem('entity'), localStorage.getItem('client'), headers).then(res => {
            let data = res.data
            setDataPayAbsenceDays(data.datasets)
            setLabelPayAbsenceDays(data.label)
            setNamePayAbsenceDays(data.name)
        }).catch(res => {
            console.log(res)
        })
    }, [])

    const barDataPayroll_budget = {
        labels: labelPayrollBudget,
        datasets: datasetsPayrollBudget
    };

    const barDataEmployee_budget = {
        labels: labelEmployeeBudget,
        datasets: datasetsEmployeeBudget
    };

    const barDataPassiveLabor = {
        labels: labelPassiveLabor,
        datasets: dataPassiveLabor
    };

    const barDataPayAbsenceType = {
        labels: labelPayAbsenceType,
        datasets: dataPayAbsenceType
    };

    const barDataPayAbsenceDays = {
        labels: labelPayAbsenceDays,
        datasets: dataPayAbsenceDays
    };

    function createPerson() {
        localStorage.removeItem('number_id');
        localStorage.removeItem('contract_id');
        history.push("/CreatePerson")
        // window.location.href = "./CreatePerson"
    }


    //Función para redirecionar a la pagina Social_benefits
    function liquidar() {
        history.push("/Novelties")
        // window.location.href = "/Social_benefits"
    }

    function facturacion() {
        history.push("/PayOrder")
        // window.location.href = "/PayOrder"
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="Agregar empleados" icon="pi pi-plus" className="p-button-success mr-2 p-button-sm " onClick={() => { localStorage.removeItem('image'); createPerson() }} />
            </React.Fragment>
        )
    }

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="Liquidar Nómina" icon="pi pi-building" className="p-button mr-2 p-button-sm " onClick={() => liquidar()} />
            </React.Fragment>
        )
    }

    const options = (nombre, tipo, grafica) => {
        const opciones = {
            plugins: {
                tooltip: {
                    position: 'average',
                    borderWidth: '100',
                    callbacks: {
                        labelTextColor: function (context) {
                            return 'white';
                        },
                        label: function (dataset) {
                            let label = dataset.label || '';
                            let data = dataset.parsed || '';
                            if (grafica !== "dona") {
                                data = dataset.parsed.y;
                            }

                            if (label) {
                                label += ': ';
                            }

                            if (tipo === 'currency') {
                                if (data !== null) {
                                    label += new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP' }).format(data);
                                }
                            }
                            else {
                                label += data;
                            }
                            return label;
                        }
                    }
                },
                title: {
                    display: true,
                    text: nombre,
                    color: 'black',
                    font: {
                        size: '20',
                    },
                    padding: {
                        top: 0
                    }
                },
                legend: {
                    align: grafica === "dona" ? 'start' : 'center',
                }
            }
        }
        return opciones
    }

    return (
        <div style={{ width: '100%' }} className='mt-6'>

            <div className="surface-100	 px-4 py-5 md:px-6 lg:px-8">
                <Toast ref={toast} />
                <Toolbar className="surface-card shadow-2 border-round mb-2" start={leftToolbarTemplate} end={rightToolbarTemplate} />
                <div className="grid">
                    {!localStorage.getItem('pay_modal') && <Dialog header={'Facturas pendientes'} visible={isOpen} contentClassName='flex justify-content-center'
                        position="center" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModal}>
                        <div className="flex justify-content-center flex-column mb-3">
                            <div className="text-900 font-medium text-xl mb-2">{pending_invoices}</div>
                            <div className="flex align-items-center justify-content-center bg-cyan-100 border-round m-auto " style={{ width: '10rem', height: '2.5rem' }} href="/Novelties">
                                <Button className="p-button-sm p-button-text text-cyan-500 -ml-2" type="button" label="Facturación" icon="pi pi-file" onClick={() => facturacion()} />
                            </div>
                        </div>
                    </Dialog>}
                    <div className="col-12 md:col-6 lg:col-3 flex flex-column justify-content-around relative">

                        <div className="surface-card shadow-2 border-round">
                            <div className="flex justify-content-center mb-3 py-3">
                                <div className="lg:col-12">
                                    <span className="block text-500 font-medium mb-1">Total Última Nómina</span>
                                    <div className="text-900 font-medium text-l">{payroll_payment}</div>
                                    <div className="flex align-items-center justify-content-center bg-cyan-100 border-round m-auto" style={{ width: '10rem', height: '2.8rem' }} href="/Novelties">
                                        <Button className="p-button-sm p-button-text text-cyan-500" type="button" label="Liquidar Nómina" icon="pi pi-building" onClick={() => liquidar()} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="surface-card shadow-2  border-round bottom-0 mb-2 py-3">
                            <div className="flex justify-content-center mb-3">
                                <div className="lg:col-12">
                                    <span className="block text-500 font-medium mb-1">Facturas pendientes</span>
                                    <div className="text-900 font-medium text-xl">{pending_invoices}</div>
                                    <div className="flex align-items-center justify-content-center bg-cyan-100 border-round m-auto " style={{ width: '10rem', height: '2.5rem' }} href="/Novelties">
                                        <Button className="p-button-sm p-button-text text-cyan-500 -ml-2" type="button" label="Facturación" icon="pi pi-file" onClick={() => facturacion()} />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="col-12 md:col-6 lg:col-5">
                        <div className="surface-card shadow-2 p-3 border-round h-full ">
                            <Chart type="bar" data={barDataPayroll_budget} options={options(namePayrollBudget, 'currency', 'bar')} />
                        </div>
                    </div>

                    <div className="col-12 md:col-6 lg:col-4">
                        <div className="surface-card flex flex-column justify-content-center shadow-2 p-3 border-round  h-full">
                            <Chart type="bar" data={barDataEmployee_budget} options={options(nameEmployeeBudget, '', 'bar')} />
                        </div>
                    </div>
                </div>
                <div className="grid">
                    <div className="col-12 md:col-6 lg:col-4">
                        <div className="surface-card flex flex-column justify-content-center shadow-2 p-3 border-round h-full ">
                            <Chart type="doughnut" data={barDataPassiveLabor} options={options('Pasivo laboral', 'currency', 'dona')} />
                            <span className="block text-500 font-medium mb-3 mt-3">Total pasivo laboral</span>
                            <div className="text-900 font-medium text-xl">{totalPassiveLabor}</div>
                        </div>
                    </div>
                    <div className="col-12 md:col-6 lg:col-4">
                        <div className="surface-card flex flex-column justify-content-center shadow-2 p-3 border-round h-full ">
                            <Chart type="doughnut" data={barDataPayAbsenceType} options={options(namePayAbsenceType, '', 'dona')} />
                        </div>
                    </div>
                    <div className="col-12 md:col-6 lg:col-4">
                        <div className="surface-card flex flex-column justify-content-center shadow-2 p-3 border-round h-full ">
                            <Chart type="line" data={barDataPayAbsenceDays} options={options(namePayAbsenceDays)} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}